/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_SubInputs */

const en_mk_desktop_sub = /** @type {(inputs: Mk_Desktop_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your account, sign in to an agent, and monitor the local connection in one window. Manage plans, reviews, and approvals in your browser.`)
};

const id_mk_desktop_sub = /** @type {(inputs: Mk_Desktop_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan akun, login ke agent, dan pantau koneksi lokal dari satu jendela. Rencana, review, dan persetujuan tetap kamu kelola di browser.`)
};

/**
* | output |
* | --- |
* | "Connect your account, sign in to an agent, and monitor the local connection in one window. Manage plans, reviews, and approvals in your browser." |
*
* @param {Mk_Desktop_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_sub = /** @type {((inputs?: Mk_Desktop_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_sub(inputs)
	return en_mk_desktop_sub(inputs)
});